import { render, staticRenderFns } from "./UserItemSelect.vue?vue&type=template&id=a90a7486&scoped=true&"
import script from "./UserItemSelect.vue?vue&type=script&lang=js&"
export * from "./UserItemSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserItemSelect.vue?vue&type=style&index=0&id=a90a7486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90a7486",
  null
  
)

export default component.exports